import { baseCommand } from "./basecommand";

type datatype = "glb"

type objectType = {
    "type" : datatype;
    "data":{
        "count": number;
        "maxCount": number;
        "glb": string;
    }
}

export class GLB extends baseCommand {

    // public MAXIMUM_SIZE_DATA_TO_SEND = 32767;

    constructor(private glb: ArrayBuffer) {
        super();
    }

    private base64encode(bytes: ArrayBuffer){
        const buffer = new Uint8Array(bytes);
        return btoa([...buffer].map(n => String.fromCharCode(n)).join(""));
    }

    public divideString(jsonStr: string, chunksize: number) {
        const datasize = jsonStr.length;
        const maxcount = Math.ceil(datasize / chunksize);

        const result: objectType[] = [];
        let count = 0;
        for (let index = 0; index < datasize; index += chunksize) {
            const senddata : objectType = {
                "type": "glb",
                "data": {
                    "count": count,
                    "maxCount": maxcount,
                    "glb": jsonStr.slice(index, index + chunksize)
                }
            };
            result.push(senddata);
            count++;
        }
        return result;
    }

    public object() {

        const glbobject : objectType = {
            "type":"glb",
            "data":{
                "count": 9999,
                "maxCount": 9999,
                "glb": ""
            }
        };

        const baseSize = JSON.stringify(glbobject).length;
        const chunksize = this.MAXIMUM_SIZE_DATA_TO_SEND - baseSize;

        const base64str = this.base64encode(this.glb);
        return this.divideString(base64str, chunksize);


        // const datasize = base64str.length;
        // const maxcount = Math.ceil(datasize / chunksize);

        // const result: objectType[] = [];
        // let count = 0;
        // for (let index = 0; index < base64str.length; index += chunksize) {
        //     const senddata : objectType = {
        //         "type": "glb",
        //         "data": {
        //             "count": count,
        //             "maxCount": maxcount,
        //             "glb": base64str.slice(index, index + chunksize)
        //         }
        //     };
        //     result.push(senddata);
        //     count++;
        // }
        // return result;
    }
}
